import { render } from "./TeacherUploadDetails.vue?vue&type=template&id=ab591dde"
import script from "./TeacherUploadDetails.vue?vue&type=script&lang=js"
export * from "./TeacherUploadDetails.vue?vue&type=script&lang=js"

import "./TeacherUploadDetails.vue?vue&type=style&index=0&id=ab591dde&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__